import axios from "axios";

const API_URL = process.env.REACT_APP_URL_API;

export const postApi = async (path, param = {}) => {
    const res = await axios.post(`${API_URL}${path}`, { param });
    return res.data;
};
